import { Draggable as DraggableDND } from 'react-beautiful-dnd';
import { DraggableItem } from './DragAndDropList.styled';

// type Props = {
//   /** Contents of the draggable. */
//   children: node,
//   /** Additional classes. */
//   className: string,
//   /** If dragging is disabled. */
//   disabled: boolean,
//   /** Class to apply when dragging it. */
//   draggingClass: string,
//   /** Unique id for this item. */
//   id: string,
//   /** Index of this item in the list. */
//   index: number,
// };

const Draggable = ({
  children,
  className,
  disabled,
  id = 'draggable',
  index,
  draggingClass = '',
}) => {
  return (
    <DraggableDND key={id} draggableId={id} index={index} isDragDisabled={disabled}>
      {(provided, snapshot) => (
        <DraggableItem
          className={`${className} ${snapshot?.isDragging ? draggingClass : ''}`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {children}
        </DraggableItem>
      )}
    </DraggableDND>
  );
};

export default Draggable;
